/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Kooperationspartnerid2Inputs */

const de__field_kooperationspartnerid2 = /** @type {(inputs: _Field_Kooperationspartnerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kooperationspartner-ID`)
};

/**

* @param {_Field_Kooperationspartnerid2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_kooperationspartnerid2 = /** @type {((inputs?: _Field_Kooperationspartnerid2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Kooperationspartnerid2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kooperationspartnerid2(inputs)
});
export { _field_kooperationspartnerid2 as "_field_kooperationspartnerID" }